var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout__header"},[_vm._t("default",[_c('app-header',{attrs:{"primary":"","full":""}},[_c('app-navbar',{attrs:{"slot":"left"},slot:"left"}),_c('app-setting',{attrs:{"slot":"right"},slot:"right"})],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }